<template>
  <v-card>
    <v-card-subtitle>
      <strong>Designated Hedges</strong>
    </v-card-subtitle>
    <v-data-table
      single-expand
      show-expand
      :expanded.sync="expanded"
      :headers="hedgeTableHeaders"
      :items="hedges"
      :items-per-page="5"
    >
      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | formatDate }}
      </template>
      <template v-slot:item.id="{ item }">
        <router-link-id
          :id="Number(item.id)"
          name="hedge"
        />
      </template>
      <template v-slot:item.pt_initial_toz="{ item }">
        <div class="pt-color text-right">
          {{ item.pt_initial_toz | toFixed(3) }}toz
          <br>
          <fx-tag
            :fx="item.alternate_pt_rate_per_toz_fx"
            :value="item.alternate_pt_rate_per_toz"
            :cur="item.currency"
          />
        </div>
      </template>
      <template v-slot:item.pd_initial_toz="{ item }">
        <div class="pd-color text-right">
          {{ item.pd_initial_toz | toFixed(3) }}toz
          <br>
          <fx-tag
            :fx="item.alternate_pd_rate_per_toz_fx"
            :value="item.alternate_pd_rate_per_toz"
            :cur="item.currency"
          />
        </div>
      </template>
      <template v-slot:item.rh_initial_toz="{ item }">
        <div class="rh-color text-right">
          {{ item.rh_initial_toz | toFixed(3) }}toz
          <br>
          <fx-tag
            :fx="item.alternate_rh_rate_per_toz_fx"
            :value="item.alternate_rh_rate_per_toz"
            :cur="item.currency"
          />
        </div>
      </template>
      <template v-slot:expanded-item="{ item }">
        <td :colspan="hedgeTableHeaders.length++">
          <div
            class="text-center"
            v-if="item.memo"
          >
            Notes: <br>
            {{ item.memo }}
          </div>
          <div
            class="text-center"
            v-else
          >
            Notes: <br>
            <b>No notes have been added</b>
          </div>
        </td>
      </template>
      <template v-slot:body.append>
        <tr>
          <td colspan="6" />
          <td>{{ totalPieces }}</td>
        </tr>
      </template>
    </v-data-table>
    <auth-guard
      can="api.change_lot"
      type="hidden"
    >
      <v-btn
        color="primary"
        small
        fab
        absolute
        bottom
        right
        @click="editDialog = !editDialog"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
      <edit-dialog
        v-model="editDialog"
        headline-text="Update Designated Hedges"
        @accept="updateHedges"
      >
        <search-autocomplete
          v-model="chipHedges"
          label="Select Hedge(s)"
          api-path="/api/lots/hedge_search/"
          multiple
          :format-entry="addFriendlyName"
        />
      </edit-dialog>
    </auth-guard>
  </v-card>
</template>

<script>
import axios from 'axios'
import SearchAutocomplete from '@/base/components/SearchAutocomplete.vue'
export default {
  name: 'DesignatedHedges',
  components: { SearchAutocomplete },
  data: () => ({
    editDialog: false,
    chipHedges: [],
    expanded: [],
    hedgeTableHeaders: [
      { text: 'Created', value: 'created_at' },
      { text: 'ID', value: 'id' },
      { text: 'Platinum', value: 'pt_initial_toz' },
      { text: 'Palladium', value: 'pd_initial_toz' },
      { text: 'Rhodium', value: 'rh_initial_toz' },
      { text: 'Pieces', value: 'pieces' }
    ]
  }),
  props: {
    hedges: { type: Array, required: true },
    url: { type: String, required: true }
  },
  watch: {
    editDialog (opened) {
      if (opened) this.chipHedges = this.hedges.map(this.addFriendlyName)
    }
  },
  computed: {
    totalPieces () {
      return this.hedges.reduce((c, h) => c + Number(h.pieces), 0)
    }
  },
  methods: {
    addFriendlyName (x) {
      return Object.assign({}, x, { friendlyName: `${x.id} ${x.code}` })
    },
    updateHedges () {
      axios.patch(this.url, { designated_hedges: this.chipHedges.map(h => h.id) }).then(() => {
        this.$emit('fetchLot')
      })
    }
  }
}
</script>
